import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: var(--c-input-error-text);
  font-size: ${(props) => props.theme.font.size.xsmall};
  margin-top: ${size(0.5)};
`;

export const Icon = styled.div`
  flex-shrink: 0;
  padding-right: ${size(0.75)};
  font-size: ${(props) => props.theme.font.size.small};
`;

export const Text = styled.div`
  flex: 1 1 auto;
`;
